import numeral from "numeral";

export const formatNumber = (number: number, format: string) => {
  if (!number) return "0";
  return numeral(number).format(format);
};
